

























import Base from "@/controllers/base.ts";
import { Component } from "vue-property-decorator";
import Crumbs from "@/components/Crumbs/index.vue";
import CContentTop from "@/components/CContentTop.vue";

@Component({
  name: "Application",
  components: {
    Crumbs,
    CContentTop
  }
})
export default class Application extends Base {
  private dataSource: any[] = [];
  private dictSource: any[] = [];
  private carouselStep = 8;

  private created() {
    this._created();
    this.getSystemDict();
    this.ssoConfigAllList();
  }

  private async goSso(id: string) {
    const res = await this.$api.GetSsoUrl(id);
    if (res && res.code === 200) {
      if (res.data.URL) {
        this._goto(res.data.URL, res.data.openWay);
        // if (res.data.openWay === "1") {
        //   this.$tools.cOpenIE(this, res.data.URL);
        // } else {
        //   this.$tools.cOpen(res.data.URL);
        // }
      } else {
        this.$message.error("跳转地址为空");
      }
    }
  }

  private async ssoConfigAllList() {
    const res = await this.$api.SsoConfigAllList();
    if (res && res.code === 200) {
      this.dataSource = res.rows;
    }
  }

  private async getSystemDict() {
    const res = await this.$api.SystemDict("outside_system_type");
    if (res && res.code === 200) {
      this.dictSource = res.data;
    }
  }

  private get dataByDict() {
    const _return: any = {};
    for (const item of this.dataSource) {
      if (!_return[item.systemType]) {
        _return[item.systemType] = [];
      }

      _return[item.systemType].push(item);
    }
    return _return;
  }
}
